import { render, staticRenderFns } from "./MonacoWrapper.vue?vue&type=template&id=2041cdcd&"
import script from "./MonacoWrapper.vue?vue&type=script&lang=js&"
export * from "./MonacoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MonacoWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports